
function StageFieldsCtrl(TranslationService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.$onInit = function () {
        ctrl.width = 100;
        ctrl.fieldNames = [];
        ctrl.fieldNames.push({
            Key: 'StageResponse',
            Value: 'StageResponse',
            Display: 'Parecer'
        });
        ctrl.fieldNames.push({
            Key: 'CreditNoteClaim',
            Value: 'CreditNoteClaim',
            Display: 'Credit Note Claim'
        });
        ctrl.fieldNames.push({
            Key: 'CreditNoteFinal',
            Value: 'CreditNoteFinal',
            Display: 'Credit Note Final'
        });
        ctrl.fieldNames.push({
            Key: 'CreditNoteOrderID',
            Value: 'CreditNoteOrderID',
            Display: 'Credit Note PO Number'
        });
        ctrl.fieldNames.push({
            Key: 'AccountNumber',
            Value: 'AccountNumber',
            Display: 'Account Number'
        });

    };

    ctrl.addField = function (index) {
        var newField = {
            IsRequired: true,
        };
        ctrl.fields.push(newField);
    };

    ctrl.selectOption = function (field, option) {
        field.FieldName = option.Key;
        field.FieldDisplay = option.Display;
    };

    ctrl.deleteField = function(index){
        ctrl.fields.splice(index, 1);
    };

}

StageFieldsCtrl.$inject = ['TranslationService'];

seedWebApp.component('stageFields', {
    controller: StageFieldsCtrl,
    controllerAs: 'ctrl',
    bindings: {
        stage: '<',
        fields: '<',
    },
    templateUrl: '/SPA/settings/stages/stageFields.html' + seedWebApp.buildVersion
});
